module.exports = __webpack_public_path__ + "img/image72.6f4b016f.jpg";